import produce from "immer";
import { SET_SAN_BALANCE, SET_USDC_BALANCE } from "../types";

const initialState = {
  usdcBalance: undefined,
  sanBalance: undefined,
  sanFaceValue: 10.0,
};

export default produce((draft: any = initialState, action) => {
  switch (action.type) {
    case SET_USDC_BALANCE: {
      draft.usdcBalance = action.payload;
      return draft;
    }
    case SET_SAN_BALANCE: {
      draft.sanBalance = action.payload;
      return draft;
    }
  }
}, initialState);
